'use strict';

module.exports = {
    navigation: function () {
        $('.container').on('change', '[name=content-navigation]', function () {
            window.location.href = this.value;
        });
    }
};
